import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";

// Get job titles
export const getJobTitles = createAsyncThunk(
  "JobTitles/getJobTitles",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();

      const currentLang = params.language || getCurrentLanguage();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.per_page) queryParams.append("per_page", params.per_page);
      if (params.search) queryParams.append("search", params.search);

      const response = await axios.get(
        `${BASE_URL}/positions${queryParams.toString() ? "?" + queryParams.toString() : ""}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get job titles!";
      return rejectWithValue({ message });
    }
  },
);

// update job title
export const updateJobTitle = createAsyncThunk(
  "JobTitles/updateJobTitle",
  async ({ id, jobTitleData, language }, { rejectWithValue }) => {
    try {
      const token = getToken();
      // Use provided language or fallback to current language
      const currentLang = language || getCurrentLanguage();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await axios.put(
        `${BASE_URL}/positions/${id}`,
        jobTitleData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      // Handle validation errors
      if (error.response?.data?.errors) {
        const errorMessages = Object.values(error.response.data.errors).flat();
        return rejectWithValue({ message: errorMessages.join(", ") });
      }
      const message =
        error.response?.data?.message || "Failed to update job title!";
      return rejectWithValue({ message });
    }
  },
);

// delete job title
export const deleteJobTitle = createAsyncThunk(
  "JobTitles/deleteJobTitle",
  async ({ id, language }, { rejectWithValue }) => {
    try {
      const token = getToken();
      // Use provided language or fallback to current language
      const currentLang = language || getCurrentLanguage();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await axios.delete(`${BASE_URL}/positions/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to delete job title!";
      return rejectWithValue({ message });
    }
  },
);

// get Job Title Details
export const getJobTitleDetails = createAsyncThunk(
  "JobTitles/getJobTitleDetails",
  async ({ id, language }, { rejectWithValue }) => {
    try {
      const token = getToken();
      // Use provided language or fallback to current language
      const currentLang = language || getCurrentLanguage();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await axios.get(`${BASE_URL}/positions/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get job title details!";
      return rejectWithValue({ message });
    }
  },
);
